import {Injectable} from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class LoggerService {
    public constructor() {
    }

    public debug(message?: any, ...optionalParams: Array<any>): void {
        if (process.env.ENV === "production") {
            return;
        }

        console.debug(message);
        if (optionalParams) {
            optionalParams.forEach(optionalParam => console.debug(optionalParam));
        }
    }

    public info(message?: any, ...optionalParams: Array<any>): void {
        console.info(message);
        if (optionalParams) {
            optionalParams.forEach(optionalParam => console.info(optionalParam));
        }
    }

    public warn(message?: any, ...optionalParams: Array<any>): void {
        console.warn(message);
        if (optionalParams) {
            optionalParams.forEach(optionalParam => console.warn(optionalParam));
        }
    }

    public error(message?: any, ...optionalParams: Array<any>): void {
        console.error(message);
        if (optionalParams) {
            optionalParams.forEach(optionalParam => console.error(optionalParam));
        }
    }
}
